module.exports = __webpack_public_path__ + "img/500-penguin.1f50c1f1.svg";